import http from './utils';
import { prefix } from './constants';

/**
 * 创建前端缓存（持久化到 MySQL）
 * 对应 API: POST /api/v1/opinion_pc/frontend/cache/create
 *
 * @param payload.url   - 前端调用 URL，用于追溯（可选，最大 512 字符）
 * @param payload.params - 缓存 JSON 字符串（必填）
 *
 * 注意：http 拦截器（@/utils/http）在成功时已解包，resolve 的是接口响应体中的内层 data
 * 字段，即 params 原文的 MD5（32 位小写十六进制字符串），而非 { code, data, msg } 整个对象。
 */
export const storeParams: (payload: {
  url?: string;
  params: string;
}) => Promise<string> = (payload) => {
  return http({
    url: `${prefix}/frontend/cache/create`,
    method: 'post',
    data: payload,
    errorHandler: true,
  }) as Promise<string>;
};

/**
 * 查询前端缓存
 * 对应 API: POST /api/v1/opinion_pc/frontend/cache/get
 *
 * @param payload.param_md5 - 创建接口返回的 32 位缓存 ID（必填）
 *
 * 注意：http 拦截器已解包，resolve 的是内层 data 字段，即对应缓存的 params 原文（JSON 字符串），
 * 不存在时为 null。调用方直接消费返回值（无需再取 .data）。
 */
export const getParams: (payload: {
  param_md5: string;
}) => Promise<string | null> = (payload) => {
  return http({
    url: `${prefix}/frontend/cache/get`,
    method: 'post',
    data: payload,
  }) as Promise<string | null>;
};
